import I18n from 'i18n-js';
import Rails from '@rails/ujs';
import ActionAssignation from '../utils/ActionAssignation';
import ChatPanel from '../../common/utils/ChatPanel';
import MoeSlotPicker from '../utils/MoeSlotPicker';
import MoeCompleteAction from '../utils/MoeCompleteAction';
import MoeSlotRequest from '../utils/MoeSlotRequest';
import { getHtmlFromAjaxResponse } from '../utils/ajaxResponseHelpers';

export default class BackofficeMoeOrdersShow {
  constructor() {
    this.actionAssignation = null;
    this.chatPanel = null;
    this.moeSlotPicker = null;
    this.moeCompleteAction = null;
    this.moeSlotRequest = null;
    this.init();
  }

  init() {
    if (this.actionAssignation) {
      this.actionAssignation.onDestroy();
    }
    this.actionAssignation = new ActionAssignation();
    this.chatPanel = new ChatPanel({ tabs: true });
    this.moeSlotPicker = new MoeSlotPicker();
    this.moeCompleteAction = new MoeCompleteAction();
    this.moeSlotRequest = new MoeSlotRequest();
    this.bindCommentButton();
  }

  bindCommentButton() {
    $('.action-comments-btn').on('click', (e) => {
      const url = $(e.currentTarget).data('url');

      Rails.ajax({
        url: url,
        type: 'GET',
        success: (response, _status, xhr) => {
          $('.action-comments-modal-body').html(getHtmlFromAjaxResponse(response, xhr));
          $('.action-comments-wrapper').scrollTop($('.action-comments-wrapper')[0].scrollHeight);
          $('#actionComments').modal('show');
          this.initDropify();
          this.bindCommentSubmit();
        }
      });
    });
  }

  bindCommentSubmit() {
    $('.action-comment-submit').off('click').on('click', (e) => {
      const form = $(e.currentTarget).closest('form')[0];
      const url = $(form).attr('action');
      const formData = new FormData(form);

      Rails.ajax({
        url: url,
        type: 'POST',
        data: formData,
        processData: false,
        success: (response) => {
          $('.action-comments-modal-body').html(response.content);

          const actionId = response.action_id;
          if (response.comments_count) {
            $(`#comments-count-action-${actionId}`).text(response.comments_count);
          }

          this.initDropify();
          this.bindCommentSubmit();
          $('#actionComments').modal('hide');
        },
        error: () => {
          this.initDropify();
          this.bindCommentSubmit();
        }
      });
    });
  }

  initDropify() {
    const $inputs = $('.dropify').filter(function () {
      return !$(this).data('dropify');
    });
    if (!$inputs.length) return;

    $inputs.dropify({
      messages: {
        default: I18n.t('plugins.dropify.messages.default'),
        replace: I18n.t('plugins.dropify.messages.replace'),
        remove:  I18n.t('plugins.dropify.messages.remove'),
        error:   I18n.t('plugins.dropify.messages.error')
      }
    });
  }

  onDestroy() {
    if (this.actionAssignation) {
      this.actionAssignation.onDestroy();
    }
    if (this.moeSlotPicker) {
      this.moeSlotPicker.onDestroy();
    }
    if (this.moeCompleteAction) {
      this.moeCompleteAction.onDestroy();
    }
    if (this.moeSlotRequest) {
      this.moeSlotRequest.onDestroy();
    }
  }
}
